import { ref, onMounted, resolveComponent, createBlock, openBlock, unref, withCtx, createElementVNode, createVNode, createElementBlock, createCommentVNode, Fragment, renderList } from "vue";
import _sfc_main$1 from "./OperationsSectionExpandedRow.vue.js";
import { POLICIES } from "../../../graphql/queries.js";
import { useApolloGlobalClient } from "../../../plugins/apollo.js";
import "lodash-es";
import "moment";
import "../../../constants/UserPolicy.js";
import "pinia";
import "../../../store/index.js";
import { useI18n } from "../../../plugins/i18n.js";
import "../../../plugins/banza/img.js";
import "axios";
import "vue-router";
import "maska";
import "../../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../../constants/components/index.js";
/* empty css                            */
import "vuetify/components/VDialog";
import "../../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                           */
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                     */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../../assets/8a32dc557a826bf0.png";
/* empty css                        */
import "../../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                    */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../../Auth/AppleAuthButton/AppleAuthButton.js";
import "../../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                                  */
import "vuetify/components/VGrid";
import "../../Base/index.js";
import "vuex";
/* empty css                           */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../../icons/mdi/index.js";
/* empty css                               */
import "vuetify/components/VBtnToggle";
import "../../../assets/6f5dc1ff0a697731.svg";
import "../../../assets/888bb8db73be3c15.svg";
/* empty css                                */
import "vuetify/components/VInfiniteScroll";
/* empty css                                     */
/* empty css                         */
import { VChip } from "vuetify/components/VChip";
/* empty css                             */
import "../../HtmlEditor/index.js";
import "../../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                                  */
/* empty css                           */
import "../../News/NewsModule/NewsModule.vue.js";
import "../../News/NewsModule/NewsList.vue.js";
import "../../../graphql/news.js";
/* empty css                           */
import "../../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                    */
import "vuetify/components/VWindow";
import "../../../assets/5a0af7dd23957928.png";
import "tiny-emitter/instance";
import "../../../graphql/system-settings.js";
/* empty css                                */
/* empty css                                       */
import "vuetify/components/VHover";
import "../../../constants/NewsGroup.js";
/* empty css                                        */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                      */
import "vuetify/components/VBottomSheet";
import "../../../graphql/favorites.js";
import "../../../plugins/tracker/page-tracker.js";
/* empty css                                */
import "../../../graphql/notifications.js";
/* empty css                                     */
import "../../../constants/CommunicationChannels.js";
/* empty css                               */
import "vuetify/components/VColorPicker";
/* empty css                                                   */
import "vuetify/components/VTextarea";
/* empty css                               */
import "vuetify/components/VTooltip";
/* empty css                                                */
/* empty css                             */
import "graphql-tag";
import "../../../graphql/lookups.js";
import "../../../graphql/entity.js";
/* empty css                          */
import "vuetify/components";
/* empty css                                */
/* empty css                        */
import "../../../graphql/system-events.js";
/* empty css                                           */
/* empty css                            */
/* empty css                            */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../../graphql/files.js";
import "vuetify/components/VForm";
/* empty css              */
/* empty css                            */
import "vuetify/components/VAlert";
/* empty css                 */
import "vue-dndrop";
/* empty css                                               */
/* empty css                                       */
import "vue-advanced-cropper";
import "../../../assets/e94e4817134d7c25.png";
import "vue-advanced-cropper/dist/style.css";
/* empty css                           */
import "vuetify/components/VFileInput";
/* empty css                               */
import "vuetify/components/VAvatar";
/* empty css                                     */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                                 */
import "../../../graphql/public-articles.js";
/* empty css                                              */
/* empty css                                  */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                     */
import "vuetify/components/VItemGroup";
/* empty css                                */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                           */
import "../../../graphql/quartz.js";
import "vue-i18n";
import "../../../graphql/integration-systems.js";
import "../../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                         */
/* empty css                                       */
import "../../../graphql/session-store.js";
import "../../../composables/useModalPage.js";
import "../../../icons/portal/index.js";
const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-wrap g-1 py-1"
};
const _hoisted_2 = ["colspan"];
const _sfc_main = {
  __name: "OperationsSection",
  setup(__props, { expose: __expose }) {
    const { t } = useI18n();
    const client = useApolloGlobalClient();
    const policies = ref([]);
    const headers = [
      { title: t("base.labels.name"), key: "name" },
      { title: t("base.labels.roles"), key: "roles", sortable: false }
    ];
    const loadData = async () => {
      const { data } = await client.query({
        query: POLICIES
      });
      policies.value = data.policies;
    };
    const reload = () => {
      loadData();
    };
    __expose({
      reload
    });
    onMounted(loadData);
    return (_ctx, _cache) => {
      const _component_b_data_table = resolveComponent("b-data-table");
      return openBlock(), createBlock(_component_b_data_table, {
        headers,
        items: unref(policies),
        "default-sort-by": [{ key: "name", order: "asc" }],
        "expand-on-click": ""
      }, {
        "item.roles": withCtx(({ item }) => {
          var _a;
          return [
            ((_a = item.roles) == null ? void 0 : _a.length) > 0 ? (openBlock(), createElementBlock("div", _hoisted_1, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(item.roles, (role) => {
                return openBlock(), createBlock(VChip, {
                  key: role.id,
                  text: role.name,
                  color: "primary"
                }, null, 8, ["text"]);
              }), 128))
            ])) : createCommentVNode("", true)
          ];
        }),
        "expanded-row": withCtx(({ item, columns, internalItem, toggleExpand }) => [
          createElementVNode("tr", null, [
            createElementVNode("td", {
              colspan: columns.length
            }, [
              createVNode(_sfc_main$1, {
                modelValue: unref(policies)[unref(policies).findIndex((i) => i.id === item.id)],
                "onUpdate:modelValue": ($event) => unref(policies)[unref(policies).findIndex((i) => i.id === item.id)] = $event,
                onClose: ($event) => toggleExpand(internalItem)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onClose"])
            ], 8, _hoisted_2)
          ])
        ]),
        _: 1
      }, 8, ["items"]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
